import { useTranslation } from "react-i18next";

export default function Loading() {
  const { t } = useTranslation();
  return (
    <div style={{
      padding: "2rem",
      textAlign: "center",
      fontSize: "1.2rem",
      opacity: 0.7
    }}>
      ⏳ {t("common.loading.safe")}
    </div>
  );
}
